import { ApolloError } from '@apollo/client';
import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { notifySuccess } from '../../utilities/notify';
import { Button } from '../common/Button/Button';
import { useClearCacheStyles } from './styles';
import { revalidateClearCache } from 'utilities/revalidation';
import { TextInput } from '@wazobia-tech/wazcom/dist/io';

const ClearCache: React.FC = () => {
  const classes = useClearCacheStyles();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<{ [key: string]: string }>({
    label: 'https://vt.co',
    url: '',
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>();

  const handleSubmit = useCallback(
    async (event: any) => {
      event.preventDefault();

      if (!data.label || !data.url) {
        setErrors({
          url: 'Incomplete URL, please select a site url and provide a slug',
        });
        return null;
      }
      setLoading(true);
      await revalidateClearCache(
        data?.url,
      )
        .then(() => {
          setLoading(false);
          notifySuccess("Successfully Purge Url");
          setData((prev) => ({
            ...prev,
            url: ""
          }));
        })
        .catch((error: ApolloError) => {
          error.graphQLErrors.map(({ message }) => toast.error(message));
        });
    },
    [data]
  );

  const handleChange = ({ target: { name, value } }: any) => {
    setData({ ...data, [name]: value });
  };

  return (
    <div>
      <p className={classes.content__title}>Clear Cache</p>
      <form className={classes.cache_form} onSubmit={handleSubmit}>
        <div className={classes.content__form_section}>
          <TextInput
            type="text"
            name="url"
            value={data?.url}
            label="Target Url"
            required
            onChange={(data) => handleChange({ target: { ...data } })}
            className={classes.content__formText}
          />
        </div>
        {errors?.url && (
          <p className={classes.content__form_error}>{errors.url}</p>
        )}
        <Button
          type="submit"
          title="Clear Cache"
          loading={loading}
          className={classes.buttonAlign}
        />
      </form>
    </div>
  );
};

export default ClearCache;
